var _defs, _rect, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMentionHookLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 252.79 206.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:.19;stroke:#1e3b8a;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#fff;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:#93c5fd;opacity:.37;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 61.85,
    y1: 239.77,
    x2: 194.15,
    y2: 107.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38bdf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34d399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 14.98,
    y1: 138.65,
    x2: 139.33,
    y2: 14.3,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfdbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dcebfe"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12,
    y: 151.59,
    width: 232,
    height: 44.06,
    rx: 9.77,
    ry: 9.77
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 12.53,
    y: 11.85,
    width: 129.24,
    height: 129.24,
    rx: 8.35,
    ry: 8.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 12.53,
    y: 49.99,
    width: 129.24,
    height: 26.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.69,
    y1: 36.75,
    x2: 34.53,
    y2: 36.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 102.36,
    y1: 63.23,
    x2: 34.53,
    y2: 63.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.36,
    y1: 89.71,
    x2: 34.53,
    y2: 89.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 113.36,
    y1: 116.2,
    x2: 34.53,
    y2: 116.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.25,168.19c-2.05-.84-4.47-1.01-6.13,.7-1.24,1.27-1.72,3.1-1.89,4.82-.19,1.91,.1,4.15,1.65,5.46,1.38,1.17,3.35,1.25,4.97,.55,2.82-1.2,3.57-4.65,3.54-7.42l-2.21,.3c.49,2.58,1.29,6.06,4.13,7,2.22,.74,4.14-.63,5.09-2.57,2.27-4.67,.84-11.17-3.23-14.38s-10.31-3.2-14.71-.69c-2.52,1.44-4.36,3.75-5.44,6.42-1.37,3.4-1.86,7.76-.75,11.29s3.95,6.42,7.52,7.65c4,1.38,8.38,.52,11.89-1.71,1.22-.77,.09-2.72-1.14-1.94-2.63,1.67-5.77,2.52-8.87,1.85-2.73-.6-5.12-2.26-6.49-4.71-1.54-2.75-1.46-6.16-.82-9.17,.54-2.54,1.68-4.91,3.66-6.64,2.94-2.57,7.43-3.21,11.1-2.01,4.44,1.45,6.59,6.22,5.96,10.66-.2,1.4-.88,3.69-2.3,3.9-2.38,.35-3.09-3.77-3.43-5.55-.24-1.26-2.23-.95-2.21,.3,.03,1.99-.35,4.96-2.65,5.52-1.64,.41-2.76-.57-3-2.2-.2-1.39,0-3.06,.65-4.31,.97-1.9,2.78-1.67,4.52-.96,1.34,.55,1.92-1.63,.6-2.17h0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentionHookLogo);
export default __webpack_public_path__ + "static/media/mention-hook-logo.b6c7ee7a819f147933f1732b94bca63f.svg";
export { ForwardRef as ReactComponent };